/**
 * Ofertas de empleo activas en E-ASY.
 * active: false oculta la oferta en /empleo sin borrar el contenido.
 */
export const JOB_OFFERS = [
  {
    id: 'responsable-marketing-b2b',
    slug: 'responsable-marketing-b2b',
    active: true,
    icon: '📣',
    title: 'Responsable de Marketing B2B',
    contract: 'Jornada completa',
    location: 'Santa Cruz de Tenerife',
    modality: 'Híbrido',
    department: 'Marketing y Comunicación',
    intro: [
      'En E-ASY buscamos una persona con visión estratégica y capacidad de ejecución para liderar el marketing B2B de la consultora: generación de demanda, posicionamiento de marca y apoyo directo al equipo comercial.',
      'Trabajamos con pymes, ONG y entidades que necesitan ERP, automatización, integración de sistemas e implantación de soluciones Kit Digital. Necesitamos alguien que sepa traducir propuestas técnicas en mensajes claros, creíbles y orientados a resultados.',
    ],
    highlight:
      'Rol clave en un momento de crecimiento: nueva convocatoria Kit Digital, landings SEO/SEM y consolidación de Vulpin 360 como producto propio.',
    responsibilities: [
      'Definir y ejecutar la estrategia de marketing B2B: posicionamiento, mensajes, canales y calendario editorial.',
      'Generar demanda cualificada: SEO, contenidos (web, blog, casos), LinkedIn, email marketing y campañas SEM cuando proceda.',
      'Crear y mantener materiales comerciales: presentaciones, one-pagers, fichas de servicio y argumentarios para el equipo de ventas.',
      'Gestionar la presencia de marca de E-ASY y Vulpin 360 con coherencia visual y de tono.',
      'Medir resultados (tráfico, leads, conversión, CPL) y proponer mejoras basadas en datos.',
      'Coordinar con consultoría y comercial para alinear mensajes en proyectos, sectores (pymes, ONG, tercer sector) y programas de ayudas.',
      'Supervisar la web corporativa, landings de captación y optimización SEO de páginas clave.',
    ],
    requirements: [
      'Experiencia demostrable en marketing B2B (mínimo 3 años), preferiblemente en tecnología, consultoría, SaaS o servicios profesionales.',
      'Dominio de contenidos digitales, SEO y redes profesionales (especialmente LinkedIn).',
      'Conocimiento práctico de campañas de pago (Google Ads, LinkedIn Ads) y analítica web.',
      'Capacidad para escribir y revisar copy orientado a conversión sin perder rigor técnico.',
      'Organización, autonomía y criterio para priorizar en un equipo ágil.',
      'Español nativo o nivel C2. Inglés técnico para documentación y herramientas.',
    ],
    niceToHave: [
      'Experiencia en sector público-subvencionado o programas como Kit Digital.',
      'Conocimiento de CRM (HubSpot u otros) y automatización de marketing.',
      'Residencia en Canarias o disponibilidad para trabajo híbrido en Tenerife.',
      'Nociones de diseño o herramientas no-code para landings y materiales.',
    ],
    benefits: [
      '🚀 Impacto directo en el crecimiento de la empresa',
      '🤝 Equipo pequeño, cercano y con autonomía real',
      '💡 Proyectos con ERP, IA, automatización y producto propio (Vulpin 360)',
      '📚 Formación continua en tecnologías y metodologías',
      '🏝️ Base en Santa Cruz de Tenerife con proyectos en toda España',
      '⏰ Horario flexible dentro de la jornada laboral',
    ],
    applicationEmail: 'comercial@e-asy.es',
    applicationSubject: 'Candidatura: Responsable de Marketing B2B — E-ASY',
  },
];

export const getActiveJobOffers = () => JOB_OFFERS.filter((job) => job.active);

export const getJobOfferBySlug = (slug) =>
  JOB_OFFERS.find((job) => job.slug === slug && job.active) ?? null;
